import { render, staticRenderFns } from "./WsTechnicalExpertsManagement.vue?vue&type=template&id=15f58b3e&scoped=true"
import script from "./WsTechnicalExpertsManagement.vue?vue&type=script&lang=js"
export * from "./WsTechnicalExpertsManagement.vue?vue&type=script&lang=js"
import style0 from "./WsTechnicalExpertsManagement.vue?vue&type=style&index=0&id=15f58b3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f58b3e",
  null
  
)

export default component.exports